<template lang="">
	<div style="display:flex; margin:3px;">
		<div v-if="label">
			<h4 style="width:150px; ">{{ label }}</h4>
		</div>
		<!-- <el-select v-model="value" :placeholder="placeholder" @change="printStatus(1, value)"> -->
		<el-select :value="value" :placeholder="placeholder" @change="onchange" :disabled="disabled">
			<el-option v-for="item in options" :key="item.value" :label="item.text" :value="item.value"> </el-option>
		</el-select>
	</div>
</template>
<script>
// let printStatus = (value, value2) => {
// 	console.log(value, value2);
// };
// console.log(props.options)
export default {
	props: ['label', 'placeholder', 'value', 'options', 'onchange', 'disabled'],
	methods: {
		// printStatus: printStatus
	},
	beforeUpdate() {
		// console.log(this);
		//console.log(this.value);
	}
};
</script>
<style lang=""></style>
